import { ReactElement, useState } from 'react';

export const useMultipleStepForm = (steps: ReactElement[]) => {
    const [currentStepIndex, setCurrentStepIndex] = useState(0);

    const next = (skipNext?: boolean) => {
        setCurrentStepIndex((i) => {
            if (i >= steps.length - 1) return i;

            let newStepIndex = i + 1;

            if (skipNext) {
                newStepIndex++;
            }

            if (newStepIndex > steps.length - 1) return i;

            return newStepIndex;
        });
    };

    const back = (skipPrevious?: boolean) => {
        setCurrentStepIndex((i) => {
            if (i <= 0) return i;

            let newStepIndex = i - 1;

            if (skipPrevious) {
                newStepIndex--;
            }

            if (newStepIndex < 0) return i;

            return newStepIndex;
        });
    };

    const goTo = (index: number) => {
        const newStepProps = steps[index].props;

        if (newStepProps?.skip) {
            return;
        }

        setCurrentStepIndex(index);
    };

    return {
        currentStepIndex,
        step: steps[currentStepIndex],
        isFirstStep: currentStepIndex === 0,
        isLastStep: currentStepIndex === steps.length - 1,
        next,
        back,
        goTo,
    };
};
